<auth-page-layout title="Welcome to the {{agency?.name}} Patient Portal"
  [logoUrl]="agency?.logoUrl"
  cardTitle="Reset Password" illustration="assets/illustration-sign-in.png">
  <form>
    <div class="form-group">
      <label for="name">Name</label>
      <input type="text" class="form-control" id="name" name="name" disabled readonly
        value="{{user?.firstName}} {{user?.lastName}}">
    </div>
    <div class="form-group">
      <label for="email">Email</label>
      <input type="text" class="form-control" id="email" name="email" disabled readonly value="{{user?.email}}">
    </div>
    <div class="form-group">
      <label for="password">Password</label>
      <input id="password" name="password" type="password" [(ngModel)]="password1" (keyup)="checkReset()"
        class="form-control" aria-describedby="emailHelp" placeholder="Enter password">
      <small id="passwordHelp" class="form-text text-muted">At least 10 characters including uppercase, lowercase,
        and a number</small>
    </div>
    <div class="form-group">
      <label for="confirm-password">Confirm Password</label>
      <input id="confirm-password" name="confirm-password" type="password" [(ngModel)]="password2"
        (keyup)="checkReset($event)" class="form-control" aria-describedby="emailHelp" placeholder="Repeat password">
      <small id="passwordMessage" class="form-text text-danger">{{passwordMessage}}</small>
    </div>
    <button (click)="resetPassword()" [disabled]="!resetAllowed" type="button" class="btn btn-primary btn-block">Sign
      In</button>
  </form>
</auth-page-layout>
